import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Check } from 'lucide-react';
export const Offer = () => {
  return <section id="offer" className="py-24 bg-wellness-sage text-wellness-forest relative overflow-hidden" data-id="element-78">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full bg-wellness-forest/5 -z-10" data-id="element-79" />

      <div className="container mx-auto px-6 max-w-5xl" data-id="element-80">
        <div className="bg-wellness-cream rounded-[2.5rem] p-8 md:p-16 shadow-2xl relative overflow-hidden" data-id="element-81">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-82">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-83">
              <h2 className="text-4xl md:text-5xl mb-6 leading-tight" data-id="element-84">
                Stop fighting your biology and{' '}
                <span className="italic text-wellness-gold-dark" data-id="element-85">
                  start listening to it.
                </span>
              </h2>

              <p className="font-sans text-lg text-wellness-forest/80 mb-8" data-id="element-86">
                Get the full protocol today for less than the cost of a single
                yoga class.
              </p>

              <div className="space-y-4 mb-10 font-sans" data-id="element-87">
                <div className="flex items-center gap-3" data-id="element-88">
                  <div className="w-6 h-6 rounded-full bg-wellness-sage/20 flex items-center justify-center shrink-0" data-id="element-89">
                    <Check className="w-4 h-4 text-wellness-forest" data-id="element-90" />
                  </div>
                  <span data-id="element-91">Instant Digital Access</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-92">
                  <div className="w-6 h-6 rounded-full bg-wellness-sage/20 flex items-center justify-center shrink-0" data-id="element-93">
                    <Check className="w-4 h-4 text-wellness-forest" data-id="element-94" />
                  </div>
                  <span data-id="element-95">No physical ship time</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-96">
                  <div className="w-6 h-6 rounded-full bg-wellness-sage/20 flex items-center justify-center shrink-0" data-id="element-97">
                    <Check className="w-4 h-4 text-wellness-forest" data-id="element-98" />
                  </div>
                  <span data-id="element-99">Start your reset in 5 minutes</span>
                </div>
              </div>

              <div className="mb-8" data-id="element-100">
                <span className="font-sans text-sm tracking-widest uppercase text-wellness-forest/60 block mb-2" data-id="element-101">
                  Total Investment
                </span>
                <span className="text-5xl font-serif text-wellness-gold-dark" data-id="element-102">
                  $6.36
                </span>
              </div>

              <Button variant="primary" size="lg" className="w-full sm:w-auto" withIcon data-id="element-103">
                Click Here to Download The Protocol
              </Button>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="relative" data-id="element-104">
              <img src="https://cdn.magicpatterns.com/uploads/gbg4mnsiUmBxJbnhJMtuF1/heylloyd-image-1778333244328.png" alt="The Menopause Belly Reset Protocol" className="w-full h-auto object-cover rounded-2xl shadow-lg transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-105" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};